import {HttpClient} from '@angular/common/http';
import { Injectable } from '@angular/core';
import { AppService } from '../shared/app.service';
import {  state2 } from '../shared/state';
import {  defaultCacheTime, IBladwijzerDb } from '../shared/offline/cobradb';
import { from as fromPromise } from 'rxjs';

export interface IPuntBladwijzer {
  AgendapuntId:number;
  ZittingId:number;
  DatumZitting:Date | string;
  SoortZitting:string;
  Titel:string;
  DatumUpdate:Date|string;
  AtHomeColorClass:string;
}

@Injectable()
export class BladwijzersService {

  constructor(private appService:AppService, private http:HttpClient) { }

  getRecenteBladwijzers() {
    const url = this.appService.getUrl('api/PuntBladwijzer/GetRecenteBladwijzers');
    return state2.getValueOrDefault('recentebladwijzers',this.http.post<IBladwijzerDb[]>(url,{}));
  }

}
